import { render, staticRenderFns } from "./desktop-root.vue?vue&type=template&id=16709328&"
import script from "./desktop-root.vue?vue&type=script&lang=ts&"
export * from "./desktop-root.vue?vue&type=script&lang=ts&"
import style0 from "./desktop-root.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "desktop-root.vue"
export default component.exports